var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6251 18.2083H20.8334L19.3699 16.7449C18.9731 16.348 18.7501 15.8097 18.7501 15.2484V11.9583C18.7501 9.23705 17.0109 6.92197 14.5834 6.06397V5.70833C14.5834 4.55774 13.6507 3.625 12.5001 3.625C11.3495 3.625 10.4167 4.55774 10.4167 5.70833V6.06397C7.98926 6.92197 6.25008 9.23705 6.25008 11.9583V15.2484C6.25008 15.8097 6.02711 16.348 5.63022 16.7449L4.16675 18.2083H9.37508M15.6251 18.2083V19.25C15.6251 20.9759 14.226 22.375 12.5001 22.375C10.7742 22.375 9.37508 20.9759 9.37508 19.25V18.2083M15.6251 18.2083H9.37508",
    stroke: "#3F3F46",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.17689a604289169521dd207f158a63af.svg";
export { ForwardRef as ReactComponent };